import { useGetBuyerSpendingLimit } from '../../../../api/lending/lapiHooks';
import { getSpendingLimitStatus } from '../../Dashboard.helpers';
import { Application } from '../../Dashboard.types';
import { DeclinedLimits } from './components/DeclinedLimits';
import { ExpiredLimits } from './components/ExpiredLimits';
import { ValidLimits } from './components/ValidLimits';

const SpendingLimitCard = ({
  setIsSpendingLimitDrawerOpen,
  refreshSpendingLimit,
  loadingRefreshSpendingLimit,
  application,
}: {
  setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  refreshSpendingLimit: () => Promise<void>;
  loadingRefreshSpendingLimit: boolean;
  application: Application | null;
}) => {
  const { spendingLimit, loadingSpendingLimit } = useGetBuyerSpendingLimit();

  const activeSpendingLimit = spendingLimit?.data?.active_spending_limit;

  if (loadingSpendingLimit || !activeSpendingLimit) return null;

  // Legacy compatibility to remove the old endpoint first
  // TODO: Check if this is still required?
  const status = getSpendingLimitStatus({
    spendingLimits: { isValid: activeSpendingLimit.is_valid },
    application,
  });

  return (
    <div>
      {status === 'valid' && (
        <ValidLimits
          setIsSpendingLimitDrawerOpen={setIsSpendingLimitDrawerOpen}
        />
      )}
      {status === 'expired' && (
        <ExpiredLimits
          setIsSpendingLimitDrawerOpen={setIsSpendingLimitDrawerOpen}
          refreshSpendingLimit={refreshSpendingLimit}
          loading={loadingRefreshSpendingLimit}
        />
      )}
      {status === 'declined' && (
        <DeclinedLimits
          setIsSpendingLimitDrawerOpen={setIsSpendingLimitDrawerOpen}
          refreshSpendingLimit={refreshSpendingLimit}
          loading={loadingRefreshSpendingLimit}
          application={application!}
        />
      )}
    </div>
  );
};

export default SpendingLimitCard;
